import React  from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux';
import { AUTHENTICATED_ENTRY } from 'configs/AppConfig'

const PublicRoute = () => {
	const { token } = useSelector(state => state.auth)
	const location = useLocation()
	
	// Login pages should redirect to dashboard if already logged in
	const authRoutes = ['/', '/login', '/auth/login-1', '/auth/login-2', '/auth/register-1', '/auth/register-2']
	const isAuthRoute = authRoutes.includes(location.pathname)
  
	// If logged in and on auth route, redirect to dashboard
	if (token && isAuthRoute) {
		return <Navigate to={AUTHENTICATED_ENTRY} />
	}

	return <Outlet/>
}

export default PublicRoute
